import React from 'react';
import { motion } from 'framer-motion';
interface ParallaxSectionProps {
  backgroundImage: string;
  children?: ReactNode;
  height?: string;
  overlayOpacity?: number;
  id?: string;
}
export function ParallaxSection({
  backgroundImage,
  children,
  height = 'h-[60vh]',
  overlayOpacity = 0.7,
  id
}: ParallaxSectionProps) {
  return <section id={id} className={`relative w-full ${height} overflow-hidden flex items-center justify-center parallax-bg`} style={{
    backgroundImage: `url(${backgroundImage})`
  }} data-id="element-193" data-mp="duncfx6fldmh">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black" style={{
      opacity: overlayOpacity
    }} data-id="element-194" data-mp="3vzgv24aka0ly" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8" data-id="element-195" data-mp="3r7fnuws9302s">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-196" data-mp="33ie9kswqkupl">
          {children}
        </motion.div>
      </div>
    </section>;
}